export enum CheckEnum {
  ACCOUNT = "account",
  BILLING = "billing"
}
